export default __webpack_public_path__ + "static/media/Paola Musatti_.453bb12f.png";